import { isNewLayoutCode } from "./layoutMeta";

const equalWidthDoorCodes = new Set([
  "dubbel",
  "dubbeleschuifdeur",
  "dubbelescharnierdeur",
  "paneelpaneel",
  "taatsdeur1paneel",
  "scharnierdeur1paneel",
  "schuifdeur1paneel",
  "dubbel2paneel",
  "dubbeleschuifdeur2paneel",
  "dubbelescharnierdeur2paneel",
]);

const standingDoubleDoorCodes = new Set([
  "dubbel",
  "dubbeleschuifdeur",
  "dubbelescharnierdeur",
  "paneelpaneel",
]);

export const requiresEqualWidths = (
  doorCode: string | null | undefined,
  layoutCode: string | null | undefined,
  hasStaander = false,
): boolean => {
  if (!doorCode || !layoutCode || !equalWidthDoorCodes.has(doorCode)) {
    return false;
  }

  if (isNewLayoutCode(layoutCode)) return true;
  return hasStaander && standingDoubleDoorCodes.has(doorCode);
};

export const hasEqualWidths = (
  widths: readonly number[] | undefined,
): boolean =>
  !!widths && widths.length > 1 && widths.every((width) => width === widths[0]);
